export const GrauParentescoList = [
  { label: 'Cônjuge', value: '1' },
  { label: 'Companheiro(a)', value: '2' },
  { label: 'Filho(a) menor não emancipado', value: '3' },
  { label: 'Filho(a) inválido(a)', value: '4' },
  {
    label: 'Pai ou mãe com dependência econômica',
    value: '5',
  },
  {
    label: 'Irmão não emancipado menor de 21 anos com dependência econômica',
    value: '6',
  },
  {
    label: 'Irmão inválido com dependência econômica',
    value: '7',
  },
  {
    label: 'Enteado não emancipado menor de 21 anos com dependência econômica',
    value: '8',
  },
  {
    label: 'Enteado inválido com dependência econômica',
    value: '9',
  },
  {
    label:
      'Menor tutelado não emancipado menor de 21 anos com dependência econômica',
    value: '10',
  },
  {
    label: 'Ex-cônjuge que recebe pensão alimentícia',
    value: '12',
  },
]

export const ResponsavelTempoList = [
  { label: 'Instituto', value: 'I' },
  { label: 'Ente', value: 'E' },
  { label: 'INSS', value: 'N' },
  { label: 'Estado', value: 'T' },
  { label: 'União', value: 'U' },
]

export const RegimePrevidenciarioList = [
  { label: 'Militar', value: 'M' },
  { label: 'RGPS', value: 'G' },
  { label: 'RPPS', value: 'P' },
]

export const TipoVinculoList = [
  { label: 'Empregado CLT', value: '1' },
  { label: 'Servidor - Cargo efetivo', value: '2' },
  { label: 'Servidor - Cargo temporário', value: '3' },
  { label: 'Servidor - Cargo comissionado exclusivo', value: '4' },
  { label: 'Militar', value: '5' },
  { label: 'Empregado público com vínculo CLT', value: '6' },
  { label: 'Exercendo mandato eletivo', value: '7' },
  { label: 'Sem vínculo', value: '8' },
  { label: 'Outro', value: '9' },
]

export const NaturezaJuridicaList = [
  { label: 'Privada', value: 'P' },
  { label: 'Pública', value: 'G' },
]

export const DocumentosList = [
  {
    codDocumento: '2',
    dcrDocumento: 'CPF do servidor (Obrigatório)',
    obrigatorio: true,
  },
  {
    codDocumento: '1',
    dcrDocumento: 'RG do servidor (Obrigatório)',
    obrigatorio: true,
  },
  {
    codDocumento: '18',
    dcrDocumento:
      'Certidão de nascimento ou casamento do servidor (Obrigatório)',
    obrigatorio: true,
  },
  {
    codDocumento: '17',
    dcrDocumento: 'Foto do rosto do servidor para identificação (Obrigatório)',
    obrigatorio: true,
  },
  {
    codDocumento: '14',
    dcrDocumento: 'CPF dos dependentes',
    obrigatorio: false,
  },
  {
    codDocumento: '15',
    dcrDocumento: 'RG dos dependentes',
    obrigatorio: false,
  },
  {
    codDocumento: '3',
    dcrDocumento:
      'CTPS – Carteira de Trabalho e Previdência Social, (página da foto, da identificação e de todos os registros)',
    obrigatorio: false,
  },
  { codDocumento: '12', dcrDocumento: 'CTC', obrigatorio: false },
  {
    codDocumento: '16',
    dcrDocumento:
      'CNIS – Cadastro Nacional de Informações Sociais, obtido através do “Meu INSS”',
    obrigatorio: false,
  },
  {
    codDocumento: '99',
    dcrDocumento: 'Outros Documentos Complementares',
    obrigatorio: false,
  },
]
